import http from 'hub-http/clients/apiClient';
import { translateLegacyOptions } from './FileSearch';
const PUBLIC_SEARCH_URI = 'files-public-search/v1/search';
export const fetchFilesAndFoldersFromPublicSearch = legacyOptions => {
  const query = translateLegacyOptions(legacyOptions, legacyOptions.category);
  return http.get(PUBLIC_SEARCH_URI, {
    query
  });
};